import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createForgotPasswordValidationSchema = Yup.object().shape({
  username: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
